import classNames from 'classnames';
import React from 'react';

import '@eika/card-style/src/SummaryCard.scss';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

export type SummaryCardProps = {
    icon: RichIconTypes;
} & React.PropsWithoutRef<React.JSX.IntrinsicElements['section']>;

const SummaryCard: React.FC<SummaryCardProps> = ({ icon, children, className, ...rest }) => {
    return (
        <section {...rest} className={classNames('sgw-summary-card__wrapper', className)}>
            <RichIcon type={icon} className="sgw-summary-card__image" />
            <>{children}</>
        </section>
    );
};

export default SummaryCard;
